module.exports = __webpack_public_path__ + "static/media/24UHCHR8.98444246.jpg";